define(["require", "exports", "hypo_bvo/Drklein/Shared/AgentInterface"], function (require, exports, AgentInterface_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getRatingPath = exports.getAgentsPath = exports.assembleAgent = exports.getAgent = exports.PlatformCommunication = void 0;
    var PlatformCommunication = /** @class */ (function () {
        function PlatformCommunication() {
        }
        PlatformCommunication.PLATFORM_PATH = function () {
            return window.platformPath;
        }();
        return PlatformCommunication;
    }());
    exports.PlatformCommunication = PlatformCommunication;
    function getAgent(id) {
        var agentPromise = $.Deferred();
        $.get(getAgentsPath() + id).done(function (agent) {
            agentPromise.resolve(assembleAgent(agent));
        }).fail(function () { return agentPromise.reject(); });
        return agentPromise;
    }
    exports.getAgent = getAgent;
    function assembleAgent(agent) {
        agent.title = agent._embedded.salutation.id == AgentInterface_1.Salutation.FEMALE ? "Spezialistin" : "Spezialist";
        agent.url = agent.profilePageUrl;
        if (agent._embedded.rating) {
            agent.rating = agent._embedded.rating.averageRating;
            agent.numberOfRatings = agent._embedded.rating.numberOfRatings;
            agent.recommendationPercent = agent._embedded.rating.recommendationPercent;
            agent.formattedRating = agent.rating ? agent.rating.toString().replace(".", ",") : undefined;
            if (agent.numberOfRatings < 1) {
                agent.numberOfRatings = undefined;
                agent.rating = undefined;
                agent.recommendationPercent = undefined;
                agent.formattedRating = undefined;
            }
        }
        agent.productGroups = agent._embedded.productGroups;
        if (agent.employeeTags) {
            agent.certificate = agent.employeeTags.includes("is_ihk_certified") ? "Immobilienfinanzierer mit IHK-Zertifikat" : "";
        }
        if (agent.type == "ASSISTANT") {
            agent.certificate = "";
            agent.title = "";
            agent.productGroups = [[0, ["id", "1"], ["name", "Teamassistenz"], ["platformId", "Teamassistenz"]]];
            agent.name = "Teamassistenz";
            agent.isAssistant = true;
        }
        if (agent._embedded.officeAllocations) {
            agent.officeAllocations = agent._embedded.officeAllocations;
        }
        return agent;
    }
    exports.assembleAgent = assembleAgent;
    function getAgentsPath() {
        return PlatformCommunication.PLATFORM_PATH + "v2/bvo-agents/";
    }
    exports.getAgentsPath = getAgentsPath;
    function getRatingPath() {
        return PlatformCommunication.PLATFORM_PATH + "v1/rating";
    }
    exports.getRatingPath = getRatingPath;
});
